module.exports = __webpack_public_path__ + "img/dracula-15.b76c9b91.jpg";